import * as moment from 'moment'
import { Pagination } from './common-model'

export interface SuggestedBaseCostResponse {
  orderId: number
  suggestedBaseCost: number
}

export enum NextLoadSuggestionsSortBy {
  Nearest = 'nearest',
  Earliest = 'earliest'
}

export interface TransportRequest {
  id: number
  created: moment.Moment
  price: number
  modified: string
  rejectionReason: RejectionReason
  state: RequestState
}

export interface MarketplaceResponse {
  marketplaceOrders: Array<OrderEntity>
  pagination: Pagination
  filters: any
}

export interface OrderEntity {
  companyTransportRequests: Array<TransportRequest>
  multiStop: MultiStop
  order: Order
}
export interface Order {
  allowedVehicleTypes: Array<string>
  arrivalNotification: boolean
  codeXl: boolean
  created: moment.Moment
  deliveryEnd: moment.Moment
  deliveryStart: moment.Moment
  directTransfer: boolean
  dockLoading: boolean
  id: number
  idForStaff: string
  isRelevant: boolean
  isTemperatureControlled: boolean
  isNextSuggested: boolean
  isCancelled: boolean
  letter: string
  loadDescription: string
  loadHeight: number
  loadLength: number
  loadMaximumTemperature: number
  loadMinimumTemperature: number
  loadQuantity: number
  loadUnitType: LoadUnitType
  loadWeight: number
  loadWidth: number
  loadingReference: string
  modified: moment.Moment
  needsPalletExchange: boolean
  pickupEnd: moment.Moment
  pickupStart: moment.Moment
  sealable: boolean
  sideLoading: boolean
  topLoading: boolean
  unloadingReference: string
  vehicleType: string
  state: OrderState
  suggestedBaseCost: number
}

export interface MultiStop {
  intermediateStops: number
  routeDistance: number
  singleStops: Array<SingleStop>
}

export interface SingleStop {
  address: Address
}

export interface Address {
  countryCode: string
  description: string
  formatted: string
  latitude: number
  locality: string
  longitude: number
  postalCode: string
}

export interface LoadSpecifications {
  weight: string
  dimensions: string
  palletInformation: string
}

export interface LoadDimensions {
  length: string
  height: string
  width: string
}

export interface PickupRange {
  pickupRangeStart: string
  pickupRangeEnd: string
}
export interface DropOffRange {
  dropOffRangeStart: string
  dropOffRangeEnd: string
}

export interface MarketplaceFilters {
  pickupRange?: PickupRange
  dropOffRange?: DropOffRange
  vehicleType?: string
  reference?: string
  pickupPlaceId?: string
  pickupLocationName?: string
  dropOffPlaceId?: string
  dropOffLocationName?: string
  maxWeight?: number
  minWeight?: number
  maxHeight?: number
  maxWidth?: number
  maxLength?: number
  transportRequestState?: RequestState
}

export type OrderState =
  | 'NEW'
  | 'REGISTERED'
  | 'CARRIER_LOCKED'
  | 'EXECUTED'
  | 'OPERATIONS_COMPLETED'
  | 'DISPATCHED'
  | 'COMPLETE'

export type RejectionReason =
  | 'PRICE_TOO_HIGH'
  | 'NOT_FITTING_THE_REQUIREMENTS'
  | 'LOW_QUALITY'
  | 'DIDNT_SEE_OFFER_IN_TIME'
  | 'AUTOMATIC_REJECTION'
  | 'CANCELLED_TOUR'

export type RequestState = 'CREATED' | 'REJECTED' | 'ACCEPTED' | 'WITHDRAWN'

export type LoadUnitType =
  | 'Europallets'
  | 'Industrial_pallets'
  | 'Coli'
  | 'Cage_Pallets'
  | 'Parcels'
  | 'Duesseldorfer_pallets'
  | 'Chep_pallets'

export enum LoadTypeName {
  Europallets = 'Europallets 1200x800',
  Industrial_pallets = 'Industrial pallets 1200x1000',
  Colli = 'Colli',
  Cage_Pallets = 'Cage Pallets',
  Parcels = 'Parcels',
  Duesseldorfer_pallets = 'Düsseldorfer pallets (800x600)',
  Chep_pallets = 'Chep pallets'
}
